<!-- Hidden image for load detection -->
<img src="/assets/img/logo-globe.jpg" style="display:none" (load)="CheckOnload()" />

<!-- Multiple Label Support with Backward Compatibility -->
@for (data of getFilteredInspectionData(); track data; let i = $index) {
  <div class="label-wrapper"
    [style.margin-bottom]="i < getFilteredInspectionData().length - 1 ? '10mm' : '0'">
    <!-- 100mm x 100mm Thermal Label Layout for TVS LP 46 NEO -->
    <div class="thermal-label-container" [class.no-barcode]="!shouldShowBarcode()"
      [class.content-dense]="isContentDense(data)">
      <!-- IATF Document Version -->
      <!-- Header Section with Company Info (left out of a plain label) -->
      @if (!isPlainLabel) {
        <div class="thermal-header">
          <div class="company-logo">
            <img src="/assets/img/logo-globe.jpg" alt="Company Logo" />
          </div>
          <div class="company-info">
            <div class="company-name">{{ Company.CompanyName }}</div>
            <div class="company-address" style="margin: 0;">{{ Company.Address }}</div>
            @if (ActiveDocumentVersion) {
              <div style="text-align: right; width: 100%; margin-top: 1px; line-height: 1;">
                <span style="font-size: 10px;">{{ActiveDocumentVersion.FormatNo}}, Rev
                {{ActiveDocumentVersion.VersionNo}}</span>
              </div>
            }
          </div>
        </div>
      }
      <!-- Main Content Section -->
      <div class="thermal-content">
        <!-- Primary Information Grid -->
        <div class="info-grid">
          <div class="info-row">
            <span class="label">ROLL NO:</span>
            <span class="value">{{ data.Code }}</span>
          </div>
          <div class="info-row">
            <span class="label">ITEM:</span>
            <span class="value">{{ JumboData.ITEMNAME }}</span>
          </div>
          <div class="info-row">
            <span class="label">P.CODE:</span>
            <span class="value">{{ JumboData.PRODUCTCODE }}</span>
          </div>
          <div class="info-row">
            <span class="label">GRAIN:</span>
            <span class="value">{{ JumboData.GRAIN }}</span>
          </div>
        </div>
        <!-- Secondary Information Grid -->
        <div class="info-grid">
          <div class="info-row">
            <span class="label">COLOR:</span>
            <span class="value">{{ JumboData.COLOUR }}</span>
          </div>
          <div class="info-row">
            <span class="label">BY:</span>
            <span class="value">{{ data.InspectedBy }}</span>
          </div>
          <div class="info-row">
            <span class="label">THICK:</span>
            <span class="value">{{ JumboData.THICKNESS }}</span>
          </div>
          <div class="info-row">
            <span class="label">WIDTH:</span>
            <span class="value">{{ JumboData.WIDTH }}</span>
          </div>
        </div>
        <!-- Tertiary Information Grid -->
        <div class="info-grid">
          <div class="info-row">
            <span class="label">LENGTH:</span>
            <span class="value">{{ data.Quantity }}</span>
          </div>
          <div class="info-row">
            <span class="label">GRADE:</span>
            <span class="value">{{ data.Grade }}</span>
          </div>
          <!-- Batch Number Row - Only show if barcode data available -->
          @if (shouldShowBarcode() && getBatchNumber(data)) {
            <div class="info-row">
              <span class="label">BATCH:</span>
              <span class="value">{{ getBatchNumber(data) }}</span>
            </div>
          }
          <div class="info-row full-width">
            <span class="label">FINISH:</span>
            <span class="value">{{ JumboData.FINISH }}</span>
          </div>
        </div>
      </div>
      <!-- Barcode and QR Code Section (when available) -->
      @if (shouldShowBarcode()) {
        <div class="thermal-barcode-section">
          <!-- Barcode on Left -->
          <div class="barcode-container">
            <svg [id]="'inspection-barcode-' + i" class="barcode-svg"></svg>
            @if (getBarcodeData(data)?.ShortCode) {
              <div class="shortcode">
                {{ getBarcodeData(data).ShortCode }}
              </div>
            }
          </div>
          <!-- QR Code on Right -->
          <div class="qr-code-container">
            <div class="qr-code-wrapper">
              <nz-qrcode [nzValue]="getQRCodeData(data)" [nzSize]="80" [nzBordered]="false" [nzLevel]="'M'">
              </nz-qrcode>
            </div>
          </div>
        </div>
      }
      <!-- Footer Warning (a plain label keeps only its format number) -->
      @if (!isPlainLabel) {
        <div class="thermal-footer">
          <div class="footer-separator"></div>
          <div class="warning-text">
            EXAMINE GOODS BEFORE CUTTING. NO CLAIMS ON CUT GOODS. RETURN WITH LABELS FOR COMPLAINTS.
          </div>
        </div>
      } @else if (ActiveDocumentVersion) {
        <div style="flex-shrink: 0; margin-top: auto; text-align: right; font-size: 10px; line-height: 1;">
          {{ActiveDocumentVersion.FormatNo}}, Rev {{ActiveDocumentVersion.VersionNo}}
        </div>
      }
    </div>
  </div>
}